import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import { FaEnvelope } from "react-icons/fa";
import "./EmailForm.css";

export const FormEmail = () => {
  const form: any = useRef();

  const sendEmail = (e: any) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "gmail",
        "template_bek9lxp",
        form.current,
        process.env.REACT_APP_EMAILJS_KEY
      )
      .then(
        (result) => {
          console.log(result.text);
          alert('e-mail sent, thanks! :)')
          e.target.reset()
        },
        (error) => {
          console.log(error.text);
          alert('an error has occured, please try again')
        }
      );
  };

  return (
    <div className="form-card">
      <div className="form-content">
        <div className="form-title">
          <h3>&#60; contact me /&#62; </h3>
          <FaEnvelope />
        </div>
        <form ref={form} onSubmit={sendEmail}>
          <p>name</p>
          <input
            className="name-input"
            placeholder=" your name"
            name="from_name"
            type="text"
            required
          />
          <p>e-mail</p>
          <input
            className="email-input"
            placeholder=" example@gmail.com"
            name="from_email"
            type="email"
            required
          />
          <p>what may I help you with?</p>
          <textarea
            name="message"
            className="text-input"
            placeholder=" max 1000 characters"
            maxLength={1000}
            required
          />
          <div className="form-footer">
            <br />
            <input className="button" type="submit" value="Send"/>
          </div>
        </form>
      </div>
    </div>
  );
};
